import { Box, Chip } from "@mui/material";
import pluralize from "pluralize";
import useColors from "../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { ReactComponent as EnvironmentIcon } from "../../../../../stack/environment/icons/sidebar_icons/sidebar-icons-environment.svg";

export const RemediatedEntitiesChip = ({ quantity }) => {
  const colors = useColors();

  return (
    <Chip
      label={
        <Box display="flex" alignItems="center" gap={1}>
          {`${quantity} ${pluralize("Entity", quantity)}`}
        </Box>
      }
      icon={
        <SvgToIcon
          IconLogo={EnvironmentIcon}
          width="16px"
          style={{
            color: colors.text_primary,
          }}
        />
      }
      style={{
        background: colors.entity_chip_enabled_fill,
        borderRadius: "8px",
        fontSize: "12px",
        color: colors.text_primary,
        boxShadow: colors.entity_chip_enabled_shadow,
        height: "24px",
        paddingLeft: "8px",
        paddingRight: "4px",
      }}
      sx={{
        "& .MuiTouchRipple-root": { display: "none !important" },
        "& .MuiChip-label": { paddingX: "4px" },
        userSelect: "none",
      }}
    />
  );
};
